import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100">
      {/* Top navigation grid */}
      <div className="px-4 md:px-8 lg:px-20 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Products */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">{t('footer.products')}</h4>
            <div className="w-8 h-[1px] bg-foreground-300 mb-4"></div>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
                  >
                    {t(cat.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">{t('footer.guides')}</h4>
            <div className="w-8 h-[1px] bg-foreground-300 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.guide_link')}
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-shipping-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.shipping_link')}
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-qc-guide" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.qc_link')}
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-vergleich" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.compare_link')}
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.faq')}
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">{t('footer.support')}</h4>
            <div className="w-8 h-[1px] bg-foreground-300 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.about')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">{t('footer.legal')}</h4>
            <div className="w-8 h-[1px] bg-foreground-300 mb-4"></div>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.terms')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors">
                  {t('footer.imprint')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-foreground-200/50 px-4 md:px-8 lg:px-20 py-10">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-3">
              <span className="text-[40px] md:text-[60px] font-heading font-extrabold text-foreground-950 leading-none">Oopbuy</span>
              <span className="text-[40px] md:text-[60px] font-heading font-extrabold text-foreground-950 leading-none">Spreadsheet</span>
            </div>
            <div className="flex items-center gap-4 mt-2">
              <div className="w-[60px] h-[2px] bg-foreground-700"></div>
              <p className="text-sm text-foreground-500">{t('footer.tagline')}</p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-900 hover:border-foreground-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-500">{t('footer.copyright')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}